"use strict";

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../../browser/parser"),
    parseFragment = _require.parseFragment;

var _require2 = require("../domparsing/serialization.js"),
    fragmentSerialization = _require2.fragmentSerialization;

var _require3 = require("../helpers/shadow-dom"),
    getRoot = _require3.getRoot;

var _require4 = require("../../utils"),
    mixin = _require4.mixin;

var DocumentFragment = require("./DocumentFragment-impl").implementation;

var DocumentOrShadowRootImpl = require("./DocumentOrShadowRoot-impl").implementation;

var ShadowRootImpl =
/*#__PURE__*/
function (_DocumentFragment) {
  _inherits(ShadowRootImpl, _DocumentFragment);

  function ShadowRootImpl(args, privateData) {
    var _this;

    _classCallCheck(this, ShadowRootImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ShadowRootImpl).call(this, args, privateData));
    var mode = privateData.mode;
    _this._mode = mode;
    return _this;
  }

  _createClass(ShadowRootImpl, [{
    key: "_getTheParent",
    value: function _getTheParent(event) {
      if (!event.composed && this === getRoot(event._path[0].item)) {
        return null;
      }

      return this._host;
    }
  }, {
    key: "mode",
    get: function get() {
      return this._mode;
    }
  }, {
    key: "host",
    get: function get() {
      return this._host;
    } // https://w3c.github.io/DOM-Parsing/#dfn-innerhtml

  }, {
    key: "innerHTML",
    get: function get() {
      return fragmentSerialization(this, {
        requireWellFormed: true
      });
    },
    set: function set(markup) {
      var fragment = parseFragment(markup, this._host);

      this._replaceAll(fragment);
    }
  }]);

  return ShadowRootImpl;
}(DocumentFragment);

mixin(ShadowRootImpl.prototype, DocumentOrShadowRootImpl.prototype);
module.exports = {
  implementation: ShadowRootImpl
};